import { useQuery } from '@tanstack/react-query'
import { supabase } from '../../api'

const getServices = async (ids) => {
    const { data: team, error: teamError } = await supabase
        .from('services_teams')
        .select(`*, teams(*), service(*)`)
        .in('service', ids)

    if (teamError) {
        throw new Error(teamError.message)
    }

    return team
}

export default function useGetServicesTeamsByServiceId(ids) {
    return useQuery({
        queryKey: ['useGetServicesTeamsByServiceId', ids],
        queryFn: () => getServices(ids),
        staleTime: 0,
        enabled: !!ids
    })
}


